<ng-container *ngIf="job$ | async as job">
  <div class="centeredBtnContainer">
    <button mat-raised-button color="primary" (click)="publishJob(job)">
      {{ 'publishMenu' | preventHardcoding }}
    </button>
  </div>
</ng-container>
